import React, { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import type { IContactBlockProps } from './contact-block';

const ContactBlock = lazy(async () => import('./contact-block'));

const el = '.fa-component--contact-block';
const DOM = document.querySelectorAll(el);

const render = function () {
    if (DOM) {
        DOM.forEach((component) => {
            const props = JSON.parse(component.getAttribute('data-props')!) as IContactBlockProps;

            createRoot(component).render(<ContactBlock {...props} />);
        });
    }
};

export default {
    render,
};
